import React from 'react';

const SkeletonLine = ({ className = '' }) => (
    <div className={`clinic-info-skeleton__line ${className}`.trim()} />
);

const SkeletonPanel = ({ children }) => (
    <div className="clinic-info-panel card clinic-info-skeleton__panel">
        <div className="clinic-info-panel__header">
            <span className="clinic-info-skeleton__icon" />
            <SkeletonLine className="clinic-info-skeleton__line--title" />
        </div>
        <div className="clinic-info-panel__body">{children}</div>
    </div>
);

function ClinicInfoSkeleton() {
    return (
        <div className="clinic-info-view clinic-info-skeleton">
            <div className="row g-3">
                <div className="col-lg-8">
                    <SkeletonPanel>
                        <div className="clinic-info-detail-grid">
                            {Array.from({ length: 5 }).map((_, index) => (
                                <div key={`basic-skeleton-${index}`} className="clinic-info-skeleton__field">
                                    <SkeletonLine className="clinic-info-skeleton__line--label" />
                                    <SkeletonLine className="clinic-info-skeleton__line--value" />
                                </div>
                            ))}
                        </div>
                    </SkeletonPanel>
                </div>

                <div className="col-lg-4">
                    <div className="clinic-info-aside">
                        <div className="clinic-info-skeleton__status card">
                            <span className="clinic-info-skeleton__status-icon" />
                            <div className="flex-grow-1">
                                <SkeletonLine className="clinic-info-skeleton__line--label mb-2" />
                                <SkeletonLine className="clinic-info-skeleton__line--medium mb-2" />
                                <SkeletonLine className="clinic-info-skeleton__line--long" />
                            </div>
                        </div>

                        <div className="clinic-info-logo-card card clinic-info-skeleton__panel">
                            <div className="clinic-info-logo-card__header">
                                <div className="clinic-info-panel__heading">
                                    <span className="clinic-info-skeleton__icon" />
                                    <SkeletonLine className="clinic-info-skeleton__line--title" />
                                </div>
                            </div>
                            <div className="clinic-info-logo-card__body">
                                <div className="clinic-info-skeleton__logo-frame" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-8">
                    <SkeletonPanel>
                        <div className="clinic-info-detail-grid">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <div key={`contact-skeleton-${index}`} className="clinic-info-skeleton__field">
                                    <SkeletonLine className="clinic-info-skeleton__line--label" />
                                    <SkeletonLine className="clinic-info-skeleton__line--value" />
                                </div>
                            ))}
                        </div>
                    </SkeletonPanel>
                </div>

                <div className="col-lg-4">
                    <div className="clinic-info-skeleton__verification card">
                        <span className="clinic-info-skeleton__status-icon" />
                        <div className="flex-grow-1">
                            <SkeletonLine className="clinic-info-skeleton__line--medium mb-2" />
                            <SkeletonLine className="clinic-info-skeleton__line--long" />
                            <SkeletonLine className="clinic-info-skeleton__line--long mt-2" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-8">
                    <SkeletonPanel>
                        <SkeletonLine className="clinic-info-skeleton__line--long mb-2" />
                        <SkeletonLine className="clinic-info-skeleton__line--medium mb-2" />
                        <SkeletonLine className="clinic-info-skeleton__line--short" />
                    </SkeletonPanel>
                </div>

                <div className="col-lg-4">
                    <div className="clinic-info-timezone-card card clinic-info-skeleton__panel">
                        <div className="clinic-info-timezone-card__header">
                            <div className="clinic-info-panel__heading">
                                <span className="clinic-info-skeleton__icon" />
                                <SkeletonLine className="clinic-info-skeleton__line--title" />
                            </div>
                        </div>
                        <div className="clinic-info-timezone-card__value">
                            <SkeletonLine className="clinic-info-skeleton__line--medium" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClinicInfoSkeleton;
